import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import TerminationForm from './TerminationForm';
import { getEmployees } from '../../../../actions/HumanResources/employeeActions';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import { createTermination } from '../../../../actions/HumanResources/terminationActions';

const TerminationCreate = (props) => {
	const { datas, loading } = props;

	useEffect(() => {
		props.getEmployees();
	}, []);

	const onSubmit = (formValues) => {
		if (!_.isEmpty(formValues)) {
			props.createTermination(formValues);
		}
	};

	return (
		<>
			{loading ? (
				<LoadingSpinner />
			) : (
				<div className="mt-3">
					<TerminationForm onSubmit={onSubmit} datas={datas} />
				</div>
			)}
		</>
	);
};

const mapStateToProps = (state) => {
	const {
		humanResources: {
			employee: { employees, getEmployeesLoading },
		},
	} = state;

	return {
		datas: { employees },
		loading: getEmployeesLoading,
	};
};

export default connect(mapStateToProps, { getEmployees, createTermination })(TerminationCreate);
